export function initHeroWithGallery() {
    const heroGalleryBackground = document.querySelector('.heroWithGalleryBackground');
    if (!document.body.querySelector('.heroWithGallery')) return;
    if (!heroGalleryBackground) return;

    document.querySelector('.mainContent').prepend(heroGalleryBackground.cloneNode(true));
    heroGalleryBackground.remove();
}